import { Button } from '@mui/material'
import React from 'react'
import { Appointment } from '../../types/treatments.types'
import FileCopyOutlinedIcon from '@mui/icons-material/FileCopyOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { useTranslation } from '../../../../../common/hooks/helper/useTranslation'
import { More } from '../../../../../common/components/BetmenList/BetmenListActions'
import { useBlackButtonStyle } from '../../../../../utils/styles/useBlackButtonStyle'
import { useTreatmentPanelData } from '../TreatmentPanel/TreatmentPanelProvider'

interface Props {
  appointment: Appointment
  isTreatmentItemPast: boolean
  editAppointment: (appointment: Appointment) => void
  cloneAppointment: (appointment: Appointment) => void
}

export const AppointmentActions: React.FC<Props> = ({
  appointment,
  isTreatmentItemPast,
  editAppointment,
  cloneAppointment,
}) => {
  const { isOwnTreatment, isAssistantOfTreatment, isTreatmentDraft } =
    useTreatmentPanelData()
  const { t } = useTranslation()
  const classes = useBlackButtonStyle()

  const canEditAppointment =
    (isOwnTreatment || isAssistantOfTreatment) &&
    (!isTreatmentItemPast || isTreatmentDraft)

  return (
    <More>
      {isOwnTreatment && (
        <Button
          classes={{ textPrimary: classes.textPrimary }}
          sx={{ justifyContent: 'flex-start' }}
          variant="text"
          onClick={(ev) => {
            ev.stopPropagation()
            cloneAppointment(appointment)
          }}
          startIcon={<FileCopyOutlinedIcon />}
        >
          {t('common:copy')}
        </Button>
      )}

      {canEditAppointment && (
        <Button
          classes={{ textPrimary: classes.textPrimary }}
          sx={{ justifyContent: 'flex-start' }}
          variant="text"
          onClick={(ev) => {
            ev.stopPropagation()
            editAppointment(appointment)
          }}
          startIcon={<EditOutlinedIcon />}
        >
          {t('common:edit')}
        </Button>
      )}
    </More>
  )
}
